import en from './translations/en.json';
import es from './translations/es.json';
import fr from './translations/fr.json';
import pt from './translations/pt.json';

type TranslationFile = {
  common: Record<string, string>;
  login: Record<string, string>;
  logout: Record<string, string>;
  notifications: Record<string, string>;
  apps?: Record<string, string>;
  header?: Record<string, string>;
  maintenance?: Record<string, string>;
};

const enTyped = en as unknown as TranslationFile;
const esTyped = es as unknown as TranslationFile;
const frTyped = fr as unknown as TranslationFile;
const ptTyped = pt as unknown as TranslationFile;

export const resources = {
  'en': {
    common: enTyped.common || {},
    login: enTyped.login || {},
    logout: enTyped.logout || {},
    notifications: enTyped.notifications || {},
    header: enTyped.header || {},
    apps: (enTyped as any).apps || {},
    maintenance: (enTyped as any).maintenance || {},
  },
  'es': {
    common: esTyped.common || {},
    login: esTyped.login || {},
    logout: esTyped.logout || {},
    notifications: esTyped.notifications || {},
    header: esTyped.header || {},
    apps: (esTyped as any).apps || {},
    maintenance: (esTyped as any).maintenance || {},
  },
  'fr': {
    common: frTyped.common || {},
    login: frTyped.login || {},
    logout: frTyped.logout || {},
    notifications: frTyped.notifications || {},
    header: frTyped.header || {},
    apps: (frTyped as any).apps || {},
    maintenance: (frTyped as any).maintenance || {},
  },
  'pt': {
    common: ptTyped.common || {},
    login: ptTyped.login || {},
    logout: ptTyped.logout || {},
    notifications: ptTyped.notifications || {},
    header: ptTyped.header || {},
    apps: (ptTyped as any).apps || {},
    maintenance: (ptTyped as any).maintenance || {},
  },
  'pt-BR': {
    common: ptTyped.common || {},
    login: ptTyped.login || {},
    logout: ptTyped.logout || {},
    notifications: ptTyped.notifications || {},
    header: ptTyped.header || {},
    apps: (ptTyped as any).apps || {},
    maintenance: (ptTyped as any).maintenance || {},
  },
} as const;

export type I18nNamespaces = keyof typeof resources.en;
export type SupportedLanguages = keyof typeof resources;
